import { FC } from 'react'

const SendIcon: FC = () => {
  return (
    <svg viewBox="0 0 20 20"><path fill="currentColor" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5" d="M2.25 2.25 17.75 10l-15.5 7.75v-4.539a1.5 1.5 0 0 1 1.46-1.5l6.54-.171a1.54 1.54 0 0 0 0-3.08l-6.54-.172a1.5 1.5 0 0 1-1.46-1.5V2.25Z"></path></svg>
  )
}

export default SendIcon
